import { Action, Dispatch } from "redux";
import { FGetState } from "../app.reducer";
/**
 * Functon type declare
 */
export type FuncAction = (
    dispatch: Dispatch,
    getState: FGetState
) => Promise<void>;

/**
 * Function sync type declare
 */
export type FuncSyncAction = (dispatch: Dispatch, getState: FGetState) => void;

/**
 * Store action type declare
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    GET_BANK_LIST: {
        LOADING: "INIT_GET_BANK_LIST_LOADING",
        SUCCESS: "INIT_GET_BANK_LIST_SUCCESS",
        ERROR: "INIT_GET_BANK_LIST_ERROR",
    },
    INIT_CHANGE_BANK: {
        LOADING: "INIT_CHANGE_BANK_LOADING",
        SUCCESS: "INIT_CHANGE_BANK_SUCCESS",
        ERROR: "INIT_CHANGE_BANK_ERROR",
    },
    SAVE_CHANGE_BANK: {
        LOADING: "SAVE_CHANGE_BANK_LOADING",
        SUCCESS: "SAVE_CHANGE_BANK_SUCCESS",
        CLEAN: "SAVE_CHANGE_BANK_CLEAN",
        ERROR: "SAVE_CHANGE_BANK_ERROR",
    },
};

/**
 * All store state
 */
export interface TransTopupBankState {
    listBank: Array<any>;
    dataInitChangeBank: any;
    dataSaveChangeBank: any;
    isLoading?: boolean;
    error?: any;
}

/**
 * Store's action definition
 */
export interface ITransTopupBankAction extends Action {
    payload: any;
    error: any;
}
